"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("./util");
class BaseSocketService {
    constructor(dataService, apiService) {
        this.dataService = dataService;
        this.apiService = apiService;
        let self = this;
        this.apiService.setSocketCallback(function (message) {
            self.socketCallback(message);
        });
    }
    socketCallback(message) {
        let self = this;
        let keys = Object.keys(message);
        keys.forEach(function (operation) {
            if (operation === 'update') {
                let updates = message[operation];
                updates.forEach(function (update) {
                    let type = Object.keys(update)[0];
                    let updateObj = update[type];
                    if (type) {
                        if (self.dataService[(0, util_1.toCamel)(type) + 's']) {
                            if (type === 'list') {
                                let item = self.dataService.lists.find((l) => ~l.requestIds.indexOf(updateObj.id));
                                if (item) {
                                    let listType = updateObj.type;
                                    item.inSet('total', updateObj.content.pagination.total);
                                    item.updateList(updateObj.content.results.map((i) => self.createObject(listType, i)), updateObj.id);
                                }
                            }
                            else {
                                let item = self.dataService[(0, util_1.toCamel)(type) + 's'].find(a => a.id === updateObj.id);
                                if (item) {
                                    Object.keys(updateObj).forEach(function (field) {
                                        if (field !== 'id') {
                                            item.inSet((0, util_1.toCamel)(field), updateObj[field]);
                                        }
                                    });
                                }
                            }
                        }
                        if (type === 'type' && update['type'] === 'resync') {
                            self.dataService.clearLists();
                            self.dataService.emitter.emit('resync');
                        }
                    }
                });
            }
            if (operation === 'delete') {
                let deletes = message[operation];
                deletes.forEach(function (update) {
                    let type = Object.keys(update)[0];
                    let deleteObj = update[type];
                    if (self.dataService[type + 's']) {
                        let item = self.dataService[type + 's'].find(a => a.id === deleteObj.id);
                        if (item) {
                            item.setDeleted();
                            self.dataService[type + 's'].splice(self.dataService[type + 's'].indexOf(item), 1);
                        }
                    }
                });
            }
        });
    }
    createObject(type, createObject) {
        return null;
    }
}
exports.default = BaseSocketService;
//# sourceMappingURL=base-socket-service.js.map